import * as types from './types'
import * as integration from '../../../integration'
import routes from '../../../config/routes'
import * as alerts from '../alerts'

export const receive = (value) => ({
  type: types.RECEIVE_PROFILE,
  payload: value
})

export const fetch = (payload = true) => ({
  type: types.FETCH_PROFILE,
  payload
})

export const getProfile = (contentFavoriteTotal) => async (dispatch) => {
  dispatch(fetch())

  try {
    const res = await integration.resources.profile.requests.getProfileResource(
      contentFavoriteTotal
    )

    dispatch(receive(res))
  } catch (err) {
    dispatch(fetch(false))
  }
}

export const updateProfile = (payload) => async (dispatch) => {
  dispatch(fetch())

  try {
    await integration.resources.profile.requests.updateProfile(payload)

    dispatch(fetch(false))
    dispatch(
      alerts.actions.receiveAlert({
        title: 'Sucesso!',
        message: 'Telefone alterado',
        action: 'redirect',
        route: routes.profile.path
      })
    )
  } catch (err) {
    dispatch(fetch(false))
    dispatch(
      alerts.actions.receiveAlert({
        title: 'Ops!',
        message: 'Algo inesperado aconteceu',
        action: 'default'
      })
    )
  }
}
